/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

(function ($) {
    "use strict"

    var spacePressed = false
    var originalVal = $.fn.val
    $.fn.val = function (value) {
        if (arguments.length >= 1) {
            if (this[0]["bootstrap-input-spinner"] && this[0].setValue) {
                this[0].setValue(value)
            }
        }
        return originalVal.apply(this, arguments)
    }

    $.fn.InputSpinner = $.fn.inputSpinner = function (options) {

      
        var config = {
            decrementButton: "-", // button text
            incrementButton: "+", // ..
            groupClass: "", // css class of the input-group (sizing with input-group-sm, input-group-lg)
          	groupHeight:"1.6rem",
            buttonsClass: "btn-outline-secondary",
          buttonWidth:"30px",
            buttonsStyle: "    border-radius: 0;" +
                "    width: 30px;" +
                "    padding: 0;" +
                "    height: 30px;" +
                "    line-height: 0;" +
                "    color: #333 !important;" +
                "    border: 1px solid #E7E7ED !important;" +
                "    background-color: #fff !important;" +
                "    font-size: 18px;\n" +
                "    font-weight: bold;",
            inputStyle: "text-align: center;\n" +
                "    height: 30px;\n" +
                "    padding: 0;\n" +
                "    min-width: 30px;\n" +
                "    border-radius: unset;\n" +
                "    width: 2rem;\n" +
                "    font-size: 15px !important;\n" +
                "    margin:0;\n" +
                "    border: unset;",
          inputFontSize : "0.85rem !important",
           inputWidth:"2rem",
          autoDelay: 500, // ms holding before auto value change
            autoInterval: 100, // speed of auto value change
            boostThreshold: 10, // boost after these steps
            boostMultiplier: "auto", // you can also set a constant number as multiplier
            locale: null // the locale for number rendering; if null, the browsers language is used
        }
        

        if (typeof Object.assign != 'function') {
          Object.assign = function(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
              throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
              var nextSource = arguments[index];

              if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                  // Avoid bugs when hasOwnProperty is shadowed
                  if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                  }
                }
              }
            }
            return to;
          };
        }

      Object.assign(config, options)
      
      var html = '<div style="    display: inline-flex;height: auto;margin-top: 0;" class="input-group ' + config.groupClass + '">' +
            '<div class="input-group-prepend">' +
            '<button style="' + config.buttonsStyle + '" class="btn btn-decrement ' + config.buttonsClass + '" type="button">' + config.decrementButton + '</button>' +
            '</div>' +
            '<input type="text" style="' + config.inputStyle +'" class="form-control"/>' +
            '<div class="input-group-append">' +
            '<button style="' + config.buttonsStyle + '" class="btn btn-increment ' + config.buttonsClass + '" type="button">' + config.incrementButton + '</button>' +
            '</div>' +
            '</div>'

        var locale = config.locale || navigator.language || "en-US"

        this.each(function () {

            var $original = $(this)
            $original[0]["bootstrap-input-spinner"] = true
            $original.hide()

            var autoDelayHandler = null
            var autoIntervalHandler = null
            var autoMultiplier = config.boostMultiplier === "auto"
            var boostMultiplier = autoMultiplier ? 1 : config.boostMultiplier

            var $inputGroup = $(html)
            var $buttonDecrement = $inputGroup.find(".btn-decrement")
            var $buttonIncrement = $inputGroup.find(".btn-increment")
            var $input = $inputGroup.find("input")

            var min = parseFloat($original.prop("min")) || 0
            var max = isNaN($original.prop("max")) || $original.prop("max") === "" ? Infinity : parseFloat($original.prop("max"))
            var step = parseFloat($original.prop("step")) || 1
            var stepMax = parseInt($original.attr("data-step-max")) || 0
            var decimals = parseInt($original.attr("data-decimals")) || 0

            var numberFormat = new Intl.NumberFormat(locale, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            })
            var value = parseFloat($original[0].value)
            var boostStepsCount = 0

            $original[0].setValue = function (newValue) {
                setValue(newValue)
            }

            if ($original.prop("class").indexOf("is-invalid") !== -1) { // TODO dynamically copy all classes
                $input.addClass("is-invalid")
            }
            if ($original.prop("class").indexOf("is-valid") !== -1) {
                $input.addClass("is-valid")
            }
            if ($original.prop("required")) {
                $input.prop("required", true)
            }
            if ($original.prop("placeholder")) {
                $input.prop("placeholder", $original.prop("placeholder"))
            }

            $original.after($inputGroup)

            if (isNaN(value)) {
                $original[0].value = ""
                $input[0].value = ""
            } else {
                $original[0].value = value
                $input[0].value = numberFormat.format(value)
            }

            $input.on("paste keyup change", function () {
                var inputValue = $input[0].value
                if (locale === "en-US" || locale === "en-GB" || locale === "th-TH") {
                    value = parseFloat(inputValue)
                } else {
                    value = parseFloat(inputValue.replace(/[. ]/g, '').replace(/,/g, '.')) // i18n
                }
                if (isNaN(value)) {
                    $original[0].value = ""
                } else {
                    $original[0].value = value
                }
                dispatchChangeEvents($original)
            })

            /*onPointerDown($buttonDecrement[0], function () {
                stepHandling(-step)
            })
            onPointerDown($buttonIncrement[0], function () {
                stepHandling(step)
            })*/
             onPointerUp($buttonDecrement[0], function () {
                stepHandling(-step)
            })
            onPointerUp($buttonIncrement[0], function () {
                stepHandling(step)
            })
            onPointerUp(document.body, function () {
                resetTimer()
            })

            function setValue(newValue) {
                if (isNaN(newValue) || newValue === "") {
                    $original[0].value = ""
                    $input[0].value = ""
                    value = 0.0
                } else {
                    $original[0].value = newValue
                    $input[0].value = numberFormat.format(newValue)
                    value = parseFloat(newValue)
                }
            }

            function dispatchChangeEvents($element) {
                setTimeout(function () {
                   // var changeEvent = new Event("change", {bubbles: true})
                   // var inputEvent = new Event("input", {bubbles: true})
                   var changeEvent = createNewEvent("change")
                    var inputEvent = createNewEvent("input")
                    $element[0].dispatchEvent(changeEvent)
                    $element[0].dispatchEvent(inputEvent)
                })
            }

            function stepHandling(step) {
                calcStep(step)
                resetTimer()
                autoDelayHandler = setTimeout(function () {
                    autoIntervalHandler = setInterval(function () {
                        if (boostStepsCount > config.boostThreshold) {
                            if (autoMultiplier) {
                                calcStep(step * parseInt(boostMultiplier, 10))
                                boostMultiplier = Math.min(1000000, boostMultiplier * 1.1)
                                if(stepMax) {
                                    boostMultiplier = Math.min(stepMax, boostMultiplier)
                                }
                            } else {
                                calcStep(step * boostMultiplier)
                            }
                        } else {
                            calcStep(step)
                        }
                        boostStepsCount++
                    }, config.autoInterval)
                }, config.autoDelay)
            }

            function calcStep(step) {
                if (isNaN(value)) {
                    value = 0
                }
                value = Math.round(value / step) * step
                value = Math.min(Math.max(value + step, min), max)
                $input[0].value = numberFormat.format(value)
                $original[0].value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
                dispatchChangeEvents($original)
            }

            function resetTimer() {
                boostStepsCount = 0
                boostMultiplier = boostMultiplier = autoMultiplier ? 1 : config.boostMultiplier
                clearTimeout(autoDelayHandler)
                clearTimeout(autoIntervalHandler)
            }

        })

    }

    function onPointerUp(element, callback) {
      	element.addEventListener("click", function (e) {
            callback(e)
        })
      	/*
        element.addEventListener("mouseup", function (e) {
            callback(e)
        })
        
        element.addEventListener("keyup", function (e) {
            if (e.keyCode === 32) {
                spacePressed = false
                callback(e)
            }
        })*/
    }

    function onPointerDown(element, callback) {
      	element.addEventListener("touchstart", function (e) {
            e.preventDefault()
            callback(e)
        })
      
        element.addEventListener("mousedown", function (e) {
            e.preventDefault()
            callback(e)
        })
        
        element.addEventListener("keydown", function (e) {
            if (e.keyCode === 32 && !spacePressed) {
                spacePressed = true
                callback(e)
            }
        })
    }
  
  function createNewEvent(eventName) {
    var event;
    if (typeof(Event) === 'function') {
      event = new Event(eventName);
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
    }
    return event;
  }

}(jQuery))